import { forwardRef, useState } from 'react';
import {
  MenuItem,
} from '@mui/material';
import LessonPlay from '../../../lessonplay/LessonPlay';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import './LessonPlayMenuItem.scss';

const defaultProps = {
  lesson: {},
  onClick: () => { },
  recordDataTo: null,
  user: null,
  userProfile: null,
  terminologies: {},
};

const LessonPlayMenuItem = forwardRef((props, ref) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { onClick, lesson, recordDataTo, user, userProfile, terminologies } = mergedProps;
  const [open, setOpen] = useState(false);

  const handleOnClick = () => {
    onClick();
    setOpen(true);
  };

  return (
    <>
      <MenuItem className='lesson-play-menu-item' onClick={handleOnClick} ref={ref} tabIndex={0}>
        <div className='lesson-play-label'>
          Play
          {recordDataTo && (
            <div className='record-data-to'>
              Will record data to <br />
              {recordDataTo}
            </div>
          )}
        </div>
      </MenuItem>
      {open && (
        <LessonPlay
          open={open}
          handleClose={() => { setOpen(false); }}
          lesson={lesson}
          user={user}
          userProfile={userProfile}
          terminologies={terminologies}
        />
      )}
    </>
  );
});

export default LessonPlayMenuItem;
